<template lang="pug">
  div.calculation.regional-tariffs
    e-toolbar(
    :items="itemsCropped"
    @deleteItems="deleteItems"
    :hideRemoveButton="true"
    :hideImportBtn="true"
    :showActionsPanel="false"
    :showTotal="false"
    :showViewPanel="false"
    :showActionsLine="false"
    )
      div(slot="filter").horizontal
        e-form-group(
        :formValidator="formValidator"
        name="_operatorName"
        realName="operator_id"
        :model="filterModel"
        :suggestionEndpoint="suggestionEndpoint"
        :transformSuggestions="transformSuggestions"
        @selectItem="selectItem"
        :suggestDelay="0"
        :minSuggestLen="2"
        :useInnerSearch="false"
        inputType="suggestion"
        :required="true"
        tabView="tab1"
        placeholder="Начните вводить название оператора..."
        ).filter-block.tko-operator
          label(
            slot="label"
          ) Оператор

        e-form-group(
        :formValidator="formValidator"
        name="_from_year"
        :model="filterModel"
        :options="fromYears"
        @change="onFilterChange"
        :required="true"
        tabView="tab1"
        inputType="select"
        ).filter-block
          label(
          slot="label"
          ) От

        e-form-group(
        :formValidator="formValidator"
        name="_to_year"
        :model="filterModel"
        :options="fromYears"
        @change="onFilterChange"
        :required="true"
        tabView="tab1"
        inputType="select"
        ).filter-block
          label(
          slot="label"
          ) До

        div(
         v-if="operatorSelected"
        ).filter-block
          e-button-add(
            v-if="tariffExist === false"
            @click="createTariff()"
          )
          e-button-delete(
            v-else
            @click="removeTariff()"
          )

    e-table(
    :items="itemsCropped"
    @deleteItem="deleteItem"
    @editItem="editItem"
    :showCheckbox="false"
    :defaultColumnWidth="100"
    :showPagination="false"
    )
       div(slot="actionButtons" slot-scope="props").buttons
         e-button-edit(
           @click="openForCalc(props)"
         ).btn-calc

    router-view
</template>

<script>
  import {mongoApi, tko} from '../../api/api-endpoints.js'
  import tariffsTableMixin from './mixins/tariffs-table-mixin'
  import {CalculationRegionalTariffs} from '../../config/mongo'

  export default {
    mixins: [tariffsTableMixin],
    methods: {
      getCreateTariffEndpoint () {
        return mongoApi.createCollectionItem(CalculationRegionalTariffs)
      },
      suggestionEndpoint (ctx, q) {
        let route = {query: {q, 'per-page': 50}}
        return tko.operators(route)
      },
      transformFilterModelToQuery (modelDeepCopy) {
        for (let key in modelDeepCopy) {
          if (key.indexOf('labelFor') > -1) {
            delete modelDeepCopy[key]
          }
        }
        return modelDeepCopy
      },
      getEndpoint (route) {
        let deepCopy = JSON.parse(JSON.stringify({
          query: route.query
        }))
        if (!deepCopy.query['filter[operator_id]']) {
          deepCopy.query['filter[operator_id]'] = 'all'
        }
        return mongoApi.getCollectionItems(CalculationRegionalTariffs, deepCopy)
      },
      getDeleteUrl (id) {
        return mongoApi.deleteCollectionItem(CalculationRegionalTariffs, id)
      }
    }
  }
</script>
